import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-bottom: 32px;

  .top {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;
    gap: 20px;
    padding-bottom: 22px;
    border-bottom: 2px solid var(--ink);
  }
`;

export const Heading = styled.div`
  > span {
    display: block;
    margin-bottom: 8px;
    font-family: var(--font-mono);
    font-size: 12px;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--accent);
  }

  h2 {
    font-size: clamp(34px, 5vw, 56px);
    font-weight: 800;
    letter-spacing: -0.035em;

    em {
      font-style: italic;
      font-weight: 400;
    }
  }

  p {
    margin-top: 8px;
    color: var(--muted);
    font-size: 14px;
  }
`;

export const Segmented = styled.div`
  display: flex;
  gap: 4px;
  max-width: 100%;
  padding: 4px;
  border-radius: 999px;
  background: var(--surface-2);
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  button {
    flex-shrink: 0;
    height: 38px;
    padding: 0 16px;
    border: 0;
    border-radius: 999px;
    background: transparent;
    font-size: 14px;
    font-weight: 500;
    color: var(--ink-2);
    cursor: pointer;
    transition: background 0.2s, color 0.2s, box-shadow 0.2s;

    &:hover {
      color: var(--ink);
    }

    &.active {
      background: var(--surface);
      color: var(--ink);
      box-shadow: var(--shadow-sm);
    }
  }
`;

export const Rail = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding-top: 16px;
  animation: fadeIn 0.4s;

  a,
  span {
    display: grid;
    place-items: center;
    min-width: 32px;
    height: 32px;
    border-radius: 8px;
    font-family: var(--font-display);
    font-size: 17px;
    font-weight: 600;
  }

  a {
    background: var(--surface);
    border: 1px solid var(--line);
    transition: background 0.2s, color 0.2s, border-color 0.2s;

    &:hover {
      background: var(--ink);
      border-color: var(--ink);
      color: var(--bg);
    }
  }

  span {
    color: var(--line);
  }
`;
